
import { defineComponent, computed } from '@nuxtjs/composition-api'
import { dateInPast } from '@/assets/date'
import { setupGtmCdpAction } from '@/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    additionalEvents: { type: Array, required: false, default: () => [] },
    showMoreEventDates: { type: Boolean, required: false, default: false },
  },
  setup({ additionalEvents }) {
    const gtmCdpAction = setupGtmCdpAction()
    const tixSaleStatuses = {
      1: 'event-detail-few-tickets-button-label',
      2: 'event-detail-sold-out-button-label',
    }

    function setStatusLabel(iConcertStatus, tixStatus) {
      if (tixStatus) {
        return tixSaleStatuses[tixStatus]
      }

      if (iConcertStatus === 'Verplaatst') {
        return 'event-detail-moved-button-label'
      }

      if (iConcertStatus === 'Geannuleerd') {
        return 'event-detail-canceled-button-label'
      }
    }

    function onSeeConcertClick() {
      gtmCdpAction('CV07 - See concert clicked')
    }

    const processedEvents = computed(() =>
      additionalEvents.map((item, index) => ({
        ...item,
        index,
        isExpired: dateInPast(item.eventEndDate || item.eventDate, 'now'),
        statusLabel: setStatusLabel(item.concertStatus, item.saleStatus),
      }))
    )

    return {
      processedEvents,
      onSeeConcertClick,
    }
  },
})
